module.exports = __webpack_public_path__ + "media/packs/src/assets/images/sign-up-success-07a90f5b006f6f8e981cc194346173c7.svg";